import * as React from "react";

/**
 * The raised reading surface every page is built out of. ScadsysIdentity writes
 * `bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden` inline at each call site;
 * this is the same look, once, in tokens.
 */

export const Card: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
    <div className={`overflow-hidden rounded-card border border-border bg-surface shadow-card ${className}`}>{children}</div>
);

export const CardHeader: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
    <div className={`border-b border-border bg-surface-muted px-6 py-4 ${className}`}>{children}</div>
);

export const CardBody: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "p-6" }) => (
    <div className={className}>{children}</div>
);

export const CardFooter: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
    <div className={`flex items-center justify-end gap-3 border-t border-border bg-surface-muted px-6 py-4 ${className}`}>{children}</div>
);

/** The standard page content width. Matches ScadsysIdentity's `max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8`. */
export const PageContainer: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
    <div className={`mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);
